import ClearIcon from "@mui/icons-material/Clear";
import IconButton from "designSystem/components/button/IconButton";
import { FlexRowCenter, GridColumn, GridRow, SingleSelect } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { grey } from "designSystem/styles/color";
import { useCustomViewGroupingStore } from "./CustomViewGroupingStore";

interface CustomViewRowAndColumnGroupingLevelProps {
	/** the index of this level */
	index: number;
}

const CustomViewRowAndColumnGroupingLevel: FunctionComponent<CustomViewRowAndColumnGroupingLevelProps> = observer((props) => {
	const {
		generateDropDownValues,
		getRowOrColumnAttributeGroupinglevel,
		groupOptions,
		removeRowOrColumnLevel,
		setColumnAttributeGroupingLevel,
		setRowAttributeGroupingLevel,
	} = useCustomViewGroupingStore();

	const {
		index,
	} = props;

	return (
		<GridColumn 
			data-csi-automation="CustomViewSortingLevel"
			spacingAroundY={2}
		>
			<GridRow
				bgcolor={grey[100]}
				growChild={0}
				spacingAroundY={2}
				standardBorder
			>
				<FlexRowCenter width="100%">
					<SingleSelect
						disableClearable
						forcePopupIcon
						fullWidth
						groupBy={(option) => option.group}
						onChange={(event, value, reason) => index === 0 ? setColumnAttributeGroupingLevel(value) : setRowAttributeGroupingLevel(value)}
						onOpenCallback={generateDropDownValues}
						options={groupOptions(getRowOrColumnAttributeGroupinglevel(index))}
						preferReactVirtuoso
						value={getRowOrColumnAttributeGroupinglevel(index)}
					/>
				</FlexRowCenter>
				<IconButton
					onClick={() => removeRowOrColumnLevel(index)}
					size="large"
				>
					<ClearIcon />
				</IconButton>
			</GridRow>
		</GridColumn>
	);
});

export default CustomViewRowAndColumnGroupingLevel;